/** Tipos de Anexos  */
export interface AnexoTipo {
    id: number;
    nome: string;
}

export const anexoTipoPDF: AnexoTipo = {id: 1, nome: 'PDF'};
export const anexoTipoTXT: AnexoTipo = {id: 2, nome: 'TXT'};
export const anexoTipoZIP: AnexoTipo = {id: 3, nome: 'ZIP'};
export const anexoTipoDOC: AnexoTipo = {id: 4, nome: 'DOC'};
export const anexoTipoPPT: AnexoTipo = {id: 5, nome: 'PPT'};
export const anexoTipoXLS: AnexoTipo = {id: 6, nome: 'XLS'};
export const anexoTipoImagem: AnexoTipo = {id: 7, nome: 'Imagem'};
export const anexoTipoAudio: AnexoTipo = {id: 8, nome: 'Audio'};
export const anexoTipoVideo: AnexoTipo = {id: 9, nome: 'Video'};
export const anexoTipoXML: AnexoTipo = {id: 10, nome: 'XML'};
export const anexoTipoOutro: AnexoTipo = {id: 99, nome: 'Outro'};

export const anexosTipos: AnexoTipo[] = [
    anexoTipoPDF,
    anexoTipoTXT,
    anexoTipoZIP,
    anexoTipoDOC,
    anexoTipoPPT,
    anexoTipoXLS,
    anexoTipoImagem,
    anexoTipoAudio,
    anexoTipoVideo,
    anexoTipoXML,
    anexoTipoOutro
];
